import { render, staticRenderFns } from "./ManageCandidateTeacher.vue?vue&type=template&id=4c86c137"
import script from "./ManageCandidateTeacher.vue?vue&type=script&lang=js"
export * from "./ManageCandidateTeacher.vue?vue&type=script&lang=js"
import style0 from "./ManageCandidateTeacher.vue?vue&type=style&index=0&id=4c86c137&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports